import { computed, makeAutoObservable } from "mobx";
import {
  UserResponseApi,
  UserResponseImpl,
} from "../DTO/ServerResponseType/User";
import {
  PathApi,
  profileSectionsByRole,
} from "../ProfileWindow/AuthComponents/profileSectionsByRole";
import { UserRoleEnum } from "../Enums/UserRoles";
import userServerClient from "../ServerClients/UserServerClient";
import { AppStoreApi } from "./AppStore";

export class UserStore {
  public user?: UserResponseImpl;
  private root: AppStoreApi;

  constructor(root: AppStoreApi) {
    makeAutoObservable(this);
    this.root = root;
  }

  async setUser(user: UserResponseImpl) {
    this.user = user;
  }

  @computed get userSections(): PathApi[] {
    if (this.user?.userRoles.includes(UserRoleEnum.admin)) {
      let profileSections = profileSectionsByRole.find(
        (sections) => sections.role === UserRoleEnum.admin
      );
      return profileSections ? profileSections.sections : [];
    }

    if (this.user?.userRoles.includes(UserRoleEnum.tutor)) {
      let profileSections = profileSectionsByRole.find(
        (sections) => sections.role === UserRoleEnum.tutor
      );
      return profileSections ? profileSections.sections : [];
    }

    return [];
  }

  async loadUserDataAsync(): Promise<UserResponseApi | never> {
    return userServerClient.sendToGetUserWithGroupsAsync().then((user) => {
      this.setUser(user);
      this.root.groupsStore.setGroups(user.userGroups);
      this.root.groupsStore.setGroupLearningPaths(user.userGroupLearningPaths);
      return this.user!;
    });
  }

  async logout() {
    this.user = undefined;
  }
}
